// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from './graphql/api/index';

import { gql } from 'graphql-tag';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const WpRedirectDocument = gql`
    query wpRedirect($currentUrl: String!) {
  redirection(input: {url: $currentUrl}) {
    __typename
    ... on RedirectionRedirect {
      code
      target
    }
  }
}
    `;

export function useWpRedirectQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.WpRedirectQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.WpRedirectQuery, SchemaTypes.WpRedirectQueryVariables | undefined>({ query: WpRedirectDocument, variables: undefined, ...options });
};